"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
var lodash_1 = require("lodash");
var fp_1 = require("lodash/fp");
var jsonpatch = require("jsonpatch");
var wix_data_schema_types_1 = require("@wix/wix-data-schema-types");
var types_1 = require("./types");
var normalizeFieldIndices = require("./normalizeFieldIndices");
var permissions_1 = require("./permissions");
var sortFieldsByIndicesAndRemoveIndices = require("./sortFieldsByIndicesAndRemoveIndices");
var isValidSchema = function (schema) { return schema && schema.fields; };
var createInitialSchema = function (collectionId, ownerAppId) { return ({
    id: collectionId,
    displayName: collectionId,
    displayField: 'title',
    fields: {
        title: {
            displayName: 'Title',
            type: wix_data_schema_types_1.FieldType.text,
            systemField: false
        }
    },
    permissions: {
        read: wix_data_schema_types_1.PermissionRole.admin,
        update: wix_data_schema_types_1.PermissionRole.admin,
        insert: wix_data_schema_types_1.PermissionRole.admin,
        remove: wix_data_schema_types_1.PermissionRole.admin
    },
    ownerAppId: ownerAppId
}); };
var postProcessSchema = fp_1.flow(normalizeFieldIndices, sortFieldsByIndicesAndRemoveIndices, permissions_1.ensurePermissions);
var createCollectionsApi = function (_a) {
    var _b = _a.transportLayer, loadSchema = _b.loadSchema, listSchemas = _b.listSchemas, saveSchema = _b.saveSchema, removeSchema = _b.removeSchema, ownerAppId = _a.ownerAppId;
    var fetchSchema = function (collectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var schema;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, loadSchema(collectionId)];
                case 1:
                    schema = _a.sent();
                    if (!isValidSchema(schema)) {
                        throw new Error('Invalid schema structure');
                    }
                    return [2, schema];
            }
        });
    }); };
    var execute = function (operation) { return __awaiter(void 0, void 0, void 0, function () {
        var collectionId, type, patches, _a, createdSchema, restoredSchema, updatedSchema, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    collectionId = operation.collectionId, type = operation.type;
                    patches = lodash_1.flatMap(operation.patches);
                    _a = type;
                    switch (_a) {
                        case types_1.SchemaOperationType.CREATE: return [3, 1];
                        case types_1.SchemaOperationType.REMOVE: return [3, 2];
                        case types_1.SchemaOperationType.RESTORE: return [3, 3];
                        case types_1.SchemaOperationType.UPDATE: return [3, 4];
                    }
                    return [3, 6];
                case 1:
                    createdSchema = normalizeFieldIndices(jsonpatch.apply_patch(createInitialSchema(collectionId, ownerAppId), patches));
                    return [2, saveSchema(collectionId, createdSchema)];
                case 2: return [2, removeSchema(collectionId)];
                case 3:
                    restoredSchema = normalizeFieldIndices(jsonpatch.apply_patch(createInitialSchema(collectionId), __spreadArrays(patches, [
                        { op: 'add', path: '/isDeleted', value: false }
                    ])));
                    return [2, saveSchema(collectionId, restoredSchema)];
                case 4:
                    _b = normalizeFieldIndices;
                    _d = (_c = jsonpatch).apply_patch;
                    return [4, fetchSchema(collectionId)];
                case 5:
                    updatedSchema = _b.apply(void 0, [_d.apply(_c, [_e.sent(), patches])]);
                    return [2, saveSchema(collectionId, updatedSchema)];
                case 6: throw Error("Unknown schema operation: " + type);
            }
        });
    }); };
    var get = function (collectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var schema;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, loadSchema(collectionId)];
                case 1:
                    schema = _a.sent();
                    return [2, isValidSchema(schema)
                            ? postProcessSchema(schema)
                            : Promise.reject(new Error('Invalid schema structure'))];
            }
        });
    }); };
    var getSome = function (collectionIds) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, listSchemas()];
                case 1: return [2, (_a.sent())
                        .filter(isValidSchema)
                        .filter(function (_a) {
                        var id = _a.id;
                        return collectionIds.includes(id);
                    })
                        .map(postProcessSchema)];
            }
        });
    }); };
    var getAll = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, listSchemas()];
                case 1: return [2, (_a.sent()).filter(isValidSchema).map(postProcessSchema)];
            }
        });
    }); };
    var getReferring = function (collectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var schemas, referringSchemas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, listSchemas()];
                case 1:
                    schemas = _a.sent();
                    referringSchemas = schemas
                        .filter(function (schema) { return collectionId !== schema.id; })
                        .filter(function (schema) {
                        return lodash_1.find(schema.fields, function (field) { return field.referencedCollection === collectionId; });
                    });
                    return [2, lodash_1.compact(referringSchemas).map(postProcessSchema)];
            }
        });
    }); };
    return {
        execute: execute,
        get: get,
        getSome: getSome,
        getAll: getAll,
        getReferring: getReferring
    };
};
exports["default"] = createCollectionsApi;
//# sourceMappingURL=api.js.map